module.exports = __webpack_public_path__ + "static/media/aboutimage.9e9d9c6c.jpg";